import { isEqual } from 'lodash/fp'
import { connect } from 'react-redux'

import { getCurrentApp } from 'e-submission/apps/selectors'
import validator from 'e-submission/domain/data-model/form/validation'

const options = {
  areStatePropsEqual: isEqual,
}

const isDeletionOnly = (currentValue, nextValue) => {
  if (typeof currentValue !== 'string' || typeof nextValue !== 'string') {
    return false
  }

  const currentCharacters = Array.from(currentValue)
  const nextCharacters = Array.from(nextValue)
  if (nextCharacters.length >= currentCharacters.length) return false

  let nextIndex = 0
  for (const character of currentCharacters) {
    if (character === nextCharacters[nextIndex]) {
      nextIndex += 1
    }
  }

  return nextIndex === nextCharacters.length
}

function EncValidation(Component) {
  return connect(
    (state, { value, required, id }) => {
      const { getValidationMessages } = validator(id)
      return getValidationMessages({
        value,
        required,
        app: getCurrentApp(state),
        state,
      })
    },
    null,
    null,
    options
  )(function EncComponent(props) {
    const { id, setValue } = props

    let _setValue = setValue
    const { allow } = validator(id)
    if (allow) {
      const currentValue = props.value
      const currentValueIsAllowed = allow(currentValue)
      _setValue = (nextValue) => {
        if (allow(nextValue) || (!currentValueIsAllowed && isDeletionOnly(currentValue, nextValue))) {
          return setValue(nextValue)
        }
      }
    }
    return <Component {...props} setValue={_setValue} allow={allow} />
  })
}

export default EncValidation
